import React, { useState, useEffect } from "react";
import AppointmentCard from "../cards/AppointmentCard";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

//Dialog
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

//Date Picker
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

//Text Field
import TextField from "@mui/material/TextField";

//Form Controls
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";

//Table Components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import moment from "moment";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

//Switch
import Switch from "@mui/material/Switch";

//Snackbar
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useSnackbar } from "notistack";

//Icons
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";

import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../auth";

//Firebase
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../firebaseConfig";

//Loader spinner
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

import { getToken, postAddSessionData } from "../APIS/clientAPIS";
import { Pagination } from "@mui/material";
import axios from "axios";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

dayjs.extend(localizedFormat);

const AppointmentDefaultView = ({ selectedTab, loading, setLoading }) => {
  const [appointmentList, setAppointmentList] = useState([]);
  const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
  const [slotsList, setSlotsList] = useState([]);
  const [checked, setChecked] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [clientData, setClientData] = useState({
    slotID: 0,
    clientID: 0,
    clientName: "",
    clientImage: "",
    clientType: "",
    appointmentID: 0,
    appointmentDate: "",
    appointmentTime: "",
    clientStatus: "",
    clientCallingMode: "",
    callDuration: "",
  });

  const [openNotesModal, setOpenNotesModal] = useState(false);
  const [note, setNote] = useState("");
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState(false);
  const [prescriptionName, setPrescriptionName] = useState("");
  const [prescriptionNote, setPrescriptionNote] = useState("");
  const [selectedFiles, setSelectedFiles] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [openCancelConfirmationModal, setOpenCancelConfirmationModal] =
    useState(false);

  // Session Notes States
  const [openSessionNotesModal, setOpenSessionNotesModal] = useState(false);
  const [sessionNotesData, setSessionNotesData] = useState({
    clientName: "",
    clientImage: "",
    clientType: "",
    clientID: "",
    country: "",
    clientMobile: "",
    clientAddress: "",
    clientState: "",
    clientCity: "",
    clientPIN: "",
    clientDOB: "",
    appointment_date: "",
    form_id: "",
    country_id: "",
    client_state_id: "",
  });

  const [sessionNotesForm, setSessionNotesForm] = useState([]);
  const [sessionNotesFormValue, setSessionNotesFormValues] = useState({
    responses: [],
  });
  const [formsList, setFormsList] = useState([]);
  const [isProceedDisabled, setIsProceedDisabled] = useState(true);
  const [isSessionNoteSaving, setIsSessionNoteSaving] = useState(false);
  const [sessionNotesStep, setSessionNotesStep] = useState(1);
  const [isFormsLoading, setIsFormsLoading] = useState(false);

  // Initialize state for text and dropdown responses
  const [textResponses, setTextResponses] = useState({});
  const [booleanResponses, setBooleanResponses] = useState({});
  const [selectionResponses, setSelectionResponses] = useState({});
  const [multiselectionResponses, setMultiselectionResponses] = useState({});
  const [dropdownResponses, setDropdownResponses] = useState({});
  const [multiQuestionRows, setMultiQuestionRows] = useState([]);
  const [textFieldsData, setTextFieldsData] = useState({});

  // Countries and states lists
  const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);

  const [bearerToken, setBearerToken] = useState(
    sessionStorage.getItem("token")
  );
  //console.log("clientData", clientData)
  //Loaders States
  const [isFileLoading, setIsFileLoading] = useState(null);
  const [isCancelled, setIsCancelled] = useState(null);
  const [isPrescriptionAdded, setIsPrescriptionAdded] = useState(null);
  const [isRescheduled, setIsRescheduled] = useState(null);
  const [isNoteAdded, setIsNoteAdded] = useState(null);
  const [arrayLength, setArrayLength] = useState(20);
  const [height, setHeight] = useState(150);
  const [width, setWidth] = useState(300);
  const [columns, setColumns] = useState();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [page, setPage] = useState(1);

  //Error States
  const [prescriptionError, setPrescriptionError] = useState(null);

  const [totalPage, setTotalPage] = useState(0);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const { currentUser } = useAuth();

  //skeleton screen size
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      let columns;

      if (screenWidth > 1500) {
        setArrayLength(20);
        columns = 4;
        setWidth(300);
        setHeight(150);
      } else if (screenWidth >= 1200 && screenWidth <= 1500) {
        setArrayLength(20);
        columns = 4;
        setWidth(240);
        setHeight(120);
      } else {
        setArrayLength(10);
        columns = 2;
        setWidth(450);
        setHeight(108);
      }
      setColumns(columns);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const headers = {
    "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
    "Content-Type": "application/json",
  };

  const postSlotsData = async () => {
    try {
      const queryParams = new URLSearchParams({
        expert_id: currentUser?.UserId,
        date: dayjs(clientData?.appointmentDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        duration: 60, // Default duration in minutes
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Gets local timezone
      });

      const response = await fetch(
        `https://us.uwc.world/new-uwc/uwc_expert/appointment/slots?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
          },
        }
      );
      const data = await response.json();
      const selectedDate = dayjs(
        clientData?.appointmentDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      const slotsForDate = data?.data?.slots[selectedDate] || [];

      const formattedSlots = slotsForDate.map((slot, index) => ({
        id: index + 1,
        slot: `${dayjs(slot.time).format("hh:mm A")} - ${dayjs(slot.time)
          .add(clientData?.appointmentDuration, "minute")
          .format("hh:mm A")}`,
        time: slot.time,
      }));

      setSlotsList(formattedSlots);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Slots List (Reschedule Dialog)
  useEffect(() => {
    if (!currentUser?.UserId) return;
    if (clientData?.appointmentDate !== "") {
      postSlotsData();
    }
  }, [clientData, currentUser?.UserId]);

  const postAppointmentsData = async () => {
    // Ensure expert ID is available before making API call
    if (!currentUser?.UserId) {
      console.warn('Expert ID not available, skipping appointments API call');
      setLoading(false);
      return;
    }

    const appointmentPayload = {
      expert_id: currentUser.UserId,
      type: selectedTab.toLowerCase(),
      datetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      page: page,
      count: 10,
    };

    setLoading(true);
    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/new-uwc/expert/dashboard/appointments`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(appointmentPayload),
        }
      );
      
      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }
      
      const postResponse = await response.json();
      const { appointments, total_pages } = postResponse?.data;

      setAppointmentList(appointments);
      setTotalPage(total_pages);
    } catch (error) {
      console.error("Error in postAppointmentsData:", error);
      // You might want to show a user-friendly error message here
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!currentUser?.UserId) return;
    postAppointmentsData();
  }, [page, currentUser?.UserId]);

  const handlePreviousPageClick = () => {
    setPage(page - 1);
    // postAppointmentsData();
  };

  const handleNextPageClick = () => {
    setPage(page + 1);
    // postAppointmentsData();
  };

  //Appointments List
  useEffect(() => {
    if (!currentUser?.UserId) return;
    postAppointmentsData();
  }, [selectedTab, currentUser?.UserId]);

  //Snackbar
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  ///Reschedule Region

  //Reschedule
  const handleReschedule = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime,
    clientCallingMode,
    clientStatus,
    callDuration
  ) => {
    // Perform actions to open the reschedule dialog
    // You can access the appointmentID, appointmentDate, and slotID here

    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
      clientCallingMode,
      clientStatus,
      callDuration,
    }));

    handleRescheduleOpen();
  };

  const handleRescheduleOpen = () => {
    setOpenRescheduleModal(true);
  };

  const handleRescheduleClose = () => {
    setOpenRescheduleModal(false);
    setClientData({
      slotID: 0,
      clientID: 0,
      clientName: "",
      clientImage: "",
      clientType: "",
      appointmentID: 0,
      appointmentDate: "",
      appointmentTime: "",
      clientStatus: "",
      clientCallingMode: "",
      callDuration: "",
    });
  };

  const onToDateChange = (date) => {
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    setClientData((prevClientData) => ({
      ...prevClientData,
      appointmentDate: formattedDate,
    }));
  };

  const handleRescheduleAppointment = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries
    setIsRescheduled(false);

    let sessionBearerToken = sessionStorage.getItem("token");

    // Format the appointment date and time
    const appointmentDateTime = dayjs(
      `${clientData?.appointmentDate} ${clientData?.appointmentTime}`,
      "DD/MM/YYYY hh:mm A"
    ).format("YYYY-MM-DD HH:mm:ss");

    const payload = {
      uwc_appointmentid: clientData?.appointmentID,
      appointment_time: appointmentDateTime,
      timezone: "Asia/Kolkata",
      token: sessionBearerToken,
      duration: parseInt(clientData?.callDuration.split(" ")[0]),
    };

    const config = {
      headers: {
        // 'accept': 'application/json, text/plain, */*',
        "content-type": "application/json",
        authorization: `Bearer ${sessionBearerToken}`,
        "x-api-key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
      },
    };

    try {
      const response = await axios.post(
        "https://us.uwc.world/new-uwc/uwc_expert/appointment/reschedule",
        payload,
        config
      );

      const postResponse = response.data;

      if (postResponse?.code === 200) {
        setSnackbarMessage("Rescheduled successfully!");
        setOpenSnackbar(true);
        handleRescheduleClose();
        setIsRescheduled(true);
        postAppointmentsData();
      } else if (postResponse?.code === 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res.accessToken);
          setTimeout(() => handleRescheduleAppointment(retryCount + 1), 0);
        });
      } else {
        setSnackbarMessage(
          postResponse?.message || "Failed to reschedule appointment"
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle axios specific errors
      const errorMessage =
        error.response?.data?.message || "An error occurred while rescheduling";
      setSnackbarMessage(errorMessage);
      setOpenSnackbar(true);
    }
  };

  //Slots Section

  const handleSlotChange = (slot) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      slotID: slot.id,
      appointmentTime: slot?.slot.split(" - ")[0],
    }));
  };

  ///Reschedule Region End

  ///Notes Region

  const handleNotes = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime,
    clientID
  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
      clientID,
    }));
    handleNotesOpen();
  };

  const handleNotesOpen = () => {
    setOpenNotesModal(true);
  };

  const handleNotesClose = () => {
    setOpenNotesModal(false);
  };

  const handleNote = (e) => {
    setNote(e.target.value);
  };

  const handlePostNote = async () => {
    setIsNoteAdded(false);
    const payload = {
      jsonrpc: "2.0",
      params: {
        name: note,
        content: note,
        creator_id: currentUser?.UserId,
        assign_id: clientData?.clientID,
        is_private: "True",
      },
    };

    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/uwc_notes/create`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );
      const postResponse = await response.json();
      if (postResponse?.ResponseCode === 200) {
        setNote("");
        setOpenNotesModal(false);
        setSnackbarMessage(postResponse?.ResponseMessage);
        setOpenSnackbar(true);
        setIsNoteAdded(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  ///Notes Region End

  ///Prescription Region

  const handlePrescription = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime,
    clientID

  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
      clientID
    }));
    setPrescriptionName(clientName);
    setPrescriptionNote(appointmentDate);
    setSelectedFiles("");
    setUploadProgress(0);
    handlePrescriptionOpen();
  };

  const handlePrescriptionOpen = () => {
    setOpenPrescriptionModal(true);
  };

  const handlePrescriptionClose = () => {
    setOpenPrescriptionModal(false);
  };

  const handlePrescriptionName = (e) => {
    setPrescriptionName(e.target.value);
  };

  const handlePrescriptionNote = (e) => {
    setPrescriptionNote(e.target.value);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handlePostPrescription = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries
    setIsPrescriptionAdded(false);

    const payload = {
      uploaded_by: "expert",
      creator_id: `${currentUser?.UserId}`,
      user_id: `${Number(clientData?.clientID)}`, // You may need to adjust this if the user_id should be different
      clinical_note_id: clientData?.appointmentID?.toString() || "",
      response: "",
      clinical_relevance: true,
      doctor_names: "",
      metadata: {
        image_url: selectedFiles,
        original_file_name: selectedFiles.split("/").pop(), // Extract filename from URL
        new_file_name: `prescription_${dayjs().toISOString()}.${selectedFiles.includes("pdf") ? "pdf" : "jpg"
          }`,
        file_type: selectedFiles.split("/")[1] || "jpg",
        file_size: formatFileSize(selectedFiles),
        category_name: "Prescription",
        doctor_name: "",
        text: prescriptionNote,
      },
    };

    const prescriptionHeaders = {
      accept: "application/json",
      token:
        "151669bf09afa74532aa8dba08a677e6d8e6e340c5c6af41c325b033970849ce40373", // You may need to use a dynamic token
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(
        "https://session-note.uwc.world/clinicalnotes/add-prescription",
        {
          method: "POST",
          headers: prescriptionHeaders,
          body: JSON.stringify(payload),
        }
      );

      const postResponse = await response.json();

      if (postResponse?.status === "success") {
        setPrescriptionName("");
        setPrescriptionNote("");
        setSelectedFiles("");
        handlePrescriptionClose();
        setSnackbarMessage(postResponse?.message);
        setOpenSnackbar(true);
        setIsPrescriptionAdded(true);
      } else if (postResponse?.ResponseCode == 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res.accessToken);
          setTimeout(() => handlePostPrescription(retryCount + 1), 0);
        });
      } else {
        console.log(postResponse?.ResponseMessage || postResponse?.message);
        setIsPrescriptionAdded(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Failed to add prescription");
      setOpenSnackbar(true);
      setIsPrescriptionAdded(true);
    }
  };

  //Upload
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];

    // File size validation (3MB limit)
    if (file.size > 3 * 1024 * 1024) {
      enqueueSnackbar("File size exceeds 3MB limit. Please select a smaller file.", { 
        variant: "error" 
      });
      // Reset file input
      event.target.value = '';
      return;
    }

    // File type validation
    if (!(file?.type.startsWith("image/") || file?.type === "application/pdf")) {
      enqueueSnackbar("Only image files (PNG, JPG, JPEG) and PDF files are allowed.", { 
        variant: "error" 
      });
      // Reset file input
      event.target.value = '';
      return;
    }

    setIsFileLoading(true);
    setUploadProgress(0);
      let dirName = moment().format("MMMM_YYYY");
      const storageRef = ref(storage, dirName + "/" + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setUploadProgress(percent);
          console.log("uploading", percent);
        },
        (err) => {
          enqueueSnackbar("File upload failed. Please try again.", { variant: "error" });
          setPrescriptionError(err);
          setIsFileLoading(false); // Stop loader on error
        },
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setSelectedFiles(url);
            setIsFileLoading(false);
          });
        }
      );
  };
  ///Prescription Region End

  ///Cancel Region

  const handleCancel = async (retryCount = 0) => {
    const MAX_RETRY = 3; // Maximum number of retries
    let sessionBearerToken = sessionStorage.getItem("token");
    setIsCancelled(false);

    const payload = {
      uwc_appointmentid: clientData?.appointmentID,
      token: sessionBearerToken,
    };

    const cancelHeaders = {
      "content-type": "application/json",
      authorization: `Bearer ${sessionBearerToken}`,
      "x-api-key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
    };

    try {
      const response = await fetch(
        `https://us.uwc.world/new-uwc/uwc_expert/appointment/cancel`,
        {
          method: "POST",
          headers: cancelHeaders,
          body: JSON.stringify(payload),
        }
      );
      const postResponse = await response.json();

      if (postResponse?.code === 200) {
        handleCancelConfirmationClose();
        setSnackbarMessage("Cancelled successfully!");
        setOpenSnackbar(true);
        setIsCancelled(true);
        postAppointmentsData();
        window.location.reload();
      } else if (postResponse?.code === 401 && retryCount < MAX_RETRY) {
        getToken(currentUser?.Emailid).then((res) => {
          setBearerToken(res?.accessToken);
          setTimeout(() => handleCancel(retryCount + 1), 0);
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCancelConfirmationOpen = () => {
    setOpenCancelConfirmationModal(true);
  };

  const handleCancelConfirmationClose = () => {
    setOpenCancelConfirmationModal(false);
  };

  const handleCancelAppointment = (
    clientName,
    clientImage,
    clientType,
    appointmentID,
    appointmentDate,
    appointmentTime
  ) => {
    setClientData((prevClientData) => ({
      ...prevClientData,
      clientName,
      clientImage,
      clientType,
      appointmentID,
      appointmentDate,
      appointmentTime,
    }));

    handleCancelConfirmationOpen();
  };

  // Session Notes Functions
  const handleSessionNotes = (
    clientName,
    clientImage,
    clientType,
    clientID,
    country,
    clientMobile,
    clientAddress,
    clientState,
    clientCity,
    clientPIN,
    clientDOB
  ) => {
    // Safety check for countriesList
    const currCountry = Array.isArray(countriesList) 
      ? countriesList.filter((item) => item.name === country)
      : [];
    
    let clientStateID = "";
    if (
      clientState !== false &&
      clientState !== undefined &&
      clientState !== null &&
      clientState !== ""
    ) {
      // Safety check for statesList
      const stateItem = Array.isArray(statesList)
        ? statesList.filter((item) => item.name == clientState)[0]
        : null;
      clientStateID = stateItem ? stateItem.id : "";
    }

    setSessionNotesData((prevData) => ({
      ...prevData,
      clientName,
      clientImage,
      clientType,
      clientID,
      country,
      clientMobile: clientMobile !== false ? clientMobile : "",
      clientAddress: clientAddress !== false ? clientAddress : "",
      clientState,
      clientCity: clientCity !== false ? clientCity : "",
      clientPIN: clientPIN !== false ? clientPIN : "",
      clientDOB: clientDOB !== false ? clientDOB : "",
      appointment_date: dayjs().format("YYYY-MM-DD"),
      country_id: currCountry[0]?.id || "",
      client_state_id: clientStateID,
    }));
    handleSessionNotesOpen();
  };

  const handleSessionNotesOpen = () => {
    setOpenSessionNotesModal(true);
    setSessionNotesStep(1);
    // Fetch forms when modal opens
    fetchForms();
    // Ensure countries and states are loaded
    if (!Array.isArray(countriesList) || countriesList.length === 0) {
      fetchCountries();
    }
    if (!Array.isArray(statesList) || statesList.length === 0) {
      fetchStates();
    }
  };

  const handleSessionNotesClose = () => {
    setOpenSessionNotesModal(false);
    setSessionNotesStep(1);
    setSessionNotesData({
      clientName: "",
      clientImage: "",
      clientType: "",
      clientID: "",
      country: "",
      clientMobile: "",
      clientAddress: "",
      clientState: "",
      clientCity: "",
      clientPIN: "",
      clientDOB: "",
      appointment_date: "",
      form_id: "",
      country_id: "",
      client_state_id: "",
    });
    setSessionNotesForm([]);
    setSessionNotesFormValues({ responses: [] });
    setTextResponses({});
    setDropdownResponses({});
    setMultiselectionResponses({});
    setBooleanResponses({});
    setMultiQuestionRows([]);
    setTextFieldsData({});
  };

  // Fetch countries and states
  const fetchCountries = async () => {
    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/new-uwc/country-list`,
        {
          method: "GET",
          headers,
        }
      );
      const data = await response.json();
      setCountriesList(data?.data || []);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await fetch(
        `https://odoo.unitedwecare.ca/new-uwc/states`,
        {
          method: "GET",
          headers,
        }
      );
      const data = await response.json();
      setStatesList(data?.data || []);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  // Fetch forms for session notes
  const fetchForms = async () => {
    if (!currentUser?.UserId) {
      console.log("Current user not available yet");
      return;
    }

    setIsFormsLoading(true);
    try {


      const response = await fetch(
        "https://us.uwc.world/new-uwc/session-notes/get-forms",
        {
          method: "GET",
          headers: {
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (data?.data) {
        setFormsList(data.data || []);
      } else {
        console.log("No forms data found in response");
        setFormsList([]);
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      setFormsList([]);
    } finally {
      setIsFormsLoading(false);
    }
  };

  // Session notes date change handler
  const onSessionNoteAppiontmentDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    setSessionNotesData((prevData) => ({
      ...prevData,
      appointment_date: formattedDate,
    }));
  };

  // Handle proceed to step 2
  const handleProceed = async () => {
    if (!sessionNotesData.form_id) {
      setSnackbarMessage("Please select a form first");
      setOpenSnackbar(true);
      return;
    }

    try {
      const resp = await postAddSessionData(JSON.stringify(sessionNotesData), 1);
      setSessionNotesForm(resp.questions);
      setSessionNotesFormValues((prevData) => ({
        ...prevData,
        session_note_id: resp.session_note_id,
        responses: [],
      }));
      setSessionNotesStep(2);
    } catch (error) {
      console.error("Error proceeding to step 2:", error);
      setSnackbarMessage("Error fetching session note forms");
      setOpenSnackbar(true);
    }
  };

  // Update response functions
  const updateResponse = (questionId, response) => {
    setSessionNotesFormValues((prevData) => {
      const existingResponseIndex = prevData.responses.findIndex(
        (resp) => resp.question_id === questionId
      );

      if (existingResponseIndex !== -1) {
        const updatedResponses = [...prevData.responses];
        updatedResponses[existingResponseIndex] = {
          ...updatedResponses[existingResponseIndex],
          ...response,
        };
        return { ...prevData, responses: updatedResponses };
      } else {
        return {
          ...prevData,
          responses: [
            ...prevData.responses,
            { question_id: questionId, ...response },
          ],
        };
      }
    });
  };

  const updateTextResponse = (questionId, responseText) => {
    const newTextResponses = { ...textResponses };
    newTextResponses[questionId] = responseText;
    setTextResponses(newTextResponses);
    updateResponse(questionId, { response_text: [responseText] });
  };

  const updateDropdownResponse = (questionId, selectedOption) => {
    const newDropdownResponses = { ...dropdownResponses };
    newDropdownResponses[questionId] = selectedOption;
    setDropdownResponses(newDropdownResponses);
    updateResponse(questionId, { option_ids: [selectedOption] });
  };

  const updateMultiselectionResponse = (questionId, selectedValues) => {
    const newMultiselectionResponses = { ...multiselectionResponses };
    newMultiselectionResponses[questionId] = selectedValues;
    setMultiselectionResponses(newMultiselectionResponses);
    const updatedResponse = selectedValues.map((value) => value.id);
    updateResponse(questionId, { option_ids: updatedResponse });
  };

  // Save session note
  const handleSaveSessionNote = async () => {
    setIsSessionNoteSaving(true);
    try {
      const response = await fetch(
        `https://us.uwc.world/new-uwc/session-notes/submit`,
        {
          method: "POST",
          headers: {
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sessionNotesFormValue),
        }
      );
      const postResponse = await response.json();

      if (postResponse.code == 200) {
        handleSessionNotesClose();
        setSnackbarMessage("Session Note added successfully!");
        setOpenSnackbar(true);

        // Clear form data
        setSessionNotesForm([]);
        setSessionNotesFormValues({});
        setSessionNotesStep(1);
        setTextResponses({});
        setDropdownResponses({});
        setMultiselectionResponses({});
        setBooleanResponses({});
        setMultiQuestionRows([]);
        setTextFieldsData({});
      } else {
        setSnackbarMessage(postResponse?.message || "Failed to save session note");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error saving session note:", error);
      setSnackbarMessage("Error saving session note");
      setOpenSnackbar(true);
    } finally {
      setIsSessionNoteSaving(false);
    }
  };

  // Effect to check if proceed button should be disabled
  useEffect(() => {
    const isDisabled = !sessionNotesData.form_id || !sessionNotesData.appointment_date || !sessionNotesData.clientMobile || !sessionNotesData.clientAddress;
    setIsProceedDisabled(isDisabled);
  }, [sessionNotesData.form_id, sessionNotesData.appointment_date, sessionNotesData.clientMobile, sessionNotesData.clientAddress]);

  // Effect to fetch countries and states on component mount
  useEffect(() => {
    if (!currentUser?.UserId) return;

    fetchCountries();
    fetchStates();
  }, [currentUser?.UserId]);

  // Effect to fetch forms when currentUser is available
  useEffect(() => {
    if (currentUser?.UserId) {
      fetchForms();
    }
  }, [currentUser?.UserId]);



  ///Cancel Region End
  const filteredSlotsData = slotsList?.filter((item) => {
    if (!checked) {
      // Render morning slots (AM)
      return item.slot.split(" - ")[0].includes("AM");
    } else {
      // Render evening slots (PM)
      return item.slot.split(" - ")[0].includes("PM");
    }
  });

  const cancelledAppointments = appointmentList?.filter(
    (item) => item.Status == "Cancelled"
  );
  const openAppointments = appointmentList?.filter(
    (item) => item.Status !== "Cancelled"
  );

  //console.log("setIsFileLoading", isFileLoading)

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: "#FFF",
          padding: "10px 10px 26px 10px",
          marginTop: "20px",
          marginLeft: 0,
          marginRight: 0,
          borderRadius: "10px",
          width: "100%",
        }}
      >
        {loading ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${columns}, 1fr)`,
              gap: "15px",
              justifyContent: "center",
              padding: "10px",
              width: "100%",
            }}
          >
            {Array.from(new Array(arrayLength)).map((_, index) => (
              <Grid
                item
                xs={6}
                lg={3}
                sx={{
                  minWidth: "100%",
                  backgroundColor: "rgb(0,0,0,0.07)",
                  padding: "10px",
                  height: "168px",
                  borderRadius: "10px",
                }}
              >
                <div className="d-flex gap-2 Card--Top my-1 p-1">
                  <Skeleton variant="circular" width={45} height={45} />

                  <div>
                    <Skeleton
                      variant="text"
                      width="8vw"
                      height={20}
                      sx={{ borderRadius: "5px" }}
                    />
                    <p>
                      <Skeleton
                        variant="text"
                        width="5vw"
                        height={20}
                        sx={{ borderRadius: "5px" }}
                      />
                    </p>
                  </div>
                </div>

                <div
                  className="Card--Timings d-flex gap-4 p-2 w-100"
                  style={{ margin: "10px 0" }}
                >
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={20}
                    sx={{ borderRadius: "5px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={20}
                    sx={{ borderRadius: "5px" }}
                  />
                </div>
                <div
                  className="d-flex gap-2 w-100"
                  style={{ margin: "10px 0" }}
                >
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={34}
                    sx={{ borderRadius: "20px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="45%"
                    height={34}
                    sx={{ borderRadius: "20px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="10%"
                    height={40}
                    sx={{ borderRadius: "20px" }}
                  />
                </div>
              </Grid>
            ))}
          </div>
        ) : appointmentList?.length === 0 ? (
          <div className="NoDataAvailable">
            <img src="/assets/img/no-appointment.png" />
            <p>No Appointment data available</p>
          </div>
        ) : (
          <Grid container spacing={2}>
            {appointmentList?.map((item, index) => (
              <Grid item xs={6} lg={3} key={item.id}>
                <AppointmentCard
                  id={item.ID}
                  clientID={item.UserId}
                  img={item.ProfileImage}
                  name={item.Name}
                  clientType={item.client_type}
                  appointmentID={item.ID}
                  appointmentDate={item.AppDate}
                  appointmentTime={item.AppTime}
                  joinURL={item.join_url}
                  status={item.Status}
                  selectedTab={selectedTab}
                  duration={item.duration}
                  can_be_cancelled={item.can_be_cancelled}
                  can_be_rescheduled={item.can_be_rescheduled}
                  onReschedule={() =>
                    handleReschedule(
                      item.Name,
                      item.ProfileImage,
                      item.client_type,
                      item.ID,
                      item.AppDate,
                      item.AppTime,
                      item.CallingMode,
                      item.Status,
                      item.duration
                    )
                  }
                  onAddNote={() =>
                    handleNotes(
                      item.Name,
                      item.ProfileImage,
                      item.client_type,
                      item.ID,
                      item.AppDate,
                      item.AppTime,
                      item.UserId,
                      item.Status
                    )
                  }
                  onPrescription={() =>
                    handlePrescription(
                      item.Name,
                      item.ProfileImage,
                      item.client_type,
                      item.ID,
                      item.AppDate,
                      item.AppTime,
                      item.UserId
                    )
                  }
                  onCancel={() =>
                    handleCancelAppointment(
                      item.Name,
                      item.ProfileImage,
                      item.client_type,
                      item.ID,
                      item.AppDate,
                      item.AppTime
                    )
                  }
                  onAddSessionNote={() =>
                    handleSessionNotes(
                      item.Name,
                      item.ProfileImage,
                      item.client_type,
                      item.UserId,
                      item.country || "",
                      item.mobile || "",
                      item.address || "",
                      item.state || "",
                      item.city || "",
                      item.pin || "",
                      item.dob || ""
                    )
                  }
                />
              </Grid>
            ))}

            <div className="d-flex justify-content-end w-100 mt-3">
              <Pagination
                count={totalPage}
                page={page}
                onChange={handleChangePage}
              />
            </div>
            {/* <div className="w-100 d-flex align-items-center justify-content-center gap-3 mt-5">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  cursor: page > 1 ? "pointer" : "not-allowed",
                  opacity: page > 1 ? 1 : 0.5
                }}
                onClick={page > 1 ? handlePreviousPageClick : null}
              >
                <ArrowBackIosIcon />
              </div>
              <div className="d-flex align-items-center justify-content-center" style={{ cursor: "pointer" }} onClick={handleNextPageClick}>
                <ArrowForwardIosIcon />
              </div>
            </div> */}
          </Grid>
        )}
      </Grid>

      {/* Notes Dialog */}
      <Dialog
        className="Dialog Notes--Dialog"
        open={openNotesModal}
        onClose={handleNotesClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isNoteAdded !== null && !isNoteAdded && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Add Notes</DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <TextField
            id="outlined-multiline-static"
            label="Write Something"
            multiline
            value={note}
            rows={4}
            fullWidth
            onChange={(e) => handleNote(e)}
            sx={{ marginTop: "20px" }}
          />

          <Button
            className="PrimaryCTA"
            variant="contained"
            disableElevation
            sx={{ margin: "30px auto 20px auto" }}
            onClick={handlePostNote}
            disabled={note == "" ? true : false}
          >
            Add Note
          </Button>
        </DialogContent>
      </Dialog>

      {/* Reschedule Dialog */}
      <Dialog
        className="Dialog Reschedule--Dialog"
        open={openRescheduleModal}
        onClose={handleRescheduleClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isRescheduled !== null && !isRescheduled && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Reschedule Appointment</DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <div>
            <h4>Reschedule to</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To date"
                format="DD/MM/YYYY"
                value={dayjs(clientData?.appointmentDate, "DD/MM/YYYY")}
                onChange={onToDateChange}
                disablePast={true}
                sx={{
                  width: "100%",
                  marginBottom: "8px",
                  backgroundColor: "#FFF",
                }}
              />
            </LocalizationProvider>
          </div>

          <div>
            <Grid
              container
              gap={2}
              sx={{ width: "100%", margin: "0" }}
              className="Timings"
            >
              {slotsList?.length > 0 ? (
                slotsList?.map((item) => (
                  <Grid
                    item
                    xs={2}
                    key={item.slot}
                    className={`AvailableSlot ${item.id == clientData?.slotID ? "SelectedSlot" : ""
                      }`}
                    onClick={() => handleSlotChange(item)}
                  >
                    <p>{item.slot.split(" - ")[0]}</p>
                  </Grid>
                ))
              ) : (
                <p className="mx-auto" style={{ fontWeight: "500" }}>
                  No slots available for selected dates
                </p>
              )}
            </Grid>
          </div>

          <Button
            className="PrimaryCTA"
            variant="contained"
            disableElevation
            sx={{ margin: "62px auto 20px auto" }}
            onClick={handleRescheduleAppointment}
            disabled={clientData.appointmentDate === "" ? true : false}
          >
            Confirm and Reschedule
          </Button>
        </DialogContent>
      </Dialog>

      {/* Precriptions Dialog */}
      <Dialog
        className="Dialog Prescription--Dialog"
        open={openPrescriptionModal}
        onClose={handlePrescriptionClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isPrescriptionAdded !== null && !isPrescriptionAdded && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogTitle>Add Prescription</DialogTitle>
        <DialogContent className="Dialog--Content">
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <TextField
            id="outlined-multiline-static"
            label="Prescription Name"
            value={prescriptionName}
            onChange={handlePrescriptionName}
            fullWidth
            sx={{ marginTop: "20px" }}
          />
          <TextField
            id="outlined-multiline-static"
            label="Prescription notes"
            value={prescriptionNote}
            onChange={handlePrescriptionNote}
            multiline
            rows={4}
            fullWidth
            sx={{ marginTop: "10px", marginBottom: "10px" }}
          />
          {(isFileLoading || uploadProgress > 0) && (
            <Box sx={{ width: "100%", margin: "10px 0", borderRadius: "10px" }}>
              <LinearProgress
                variant="determinate"
                value={uploadProgress}
                color={uploadProgress === 100 ? "success" : "secondary"}
              />
            </Box>
          )}

          <span style={{ fontSize: "12px", color: "gray", fontWeight: "600" }}>
            Only .jpg, .jpeg, .png, .pdf allowed up to 2mb
          </span>

          <div
            className="upload-button"
            style={{ marginTop: "0", height: "100%" }}
          >
            <label
              htmlFor="file-upload"
              className="upload-button-label"
              style={{ height: "100%", fontSize: "16px" }}
            >
              <FileUploadOutlinedIcon className="upload-button-icon" />
              Upload
            </label>

            {isFileLoading && uploadProgress >= 0 && uploadProgress < 100 ? (
              <div className="d-flex align-items-center mx-auto">
                <CircularProgress
                  sx={{ width: "20px !important", height: "20px !important" }}
                />
              </div>
            ) : (
              <>
                <input
                  id="file-upload"
                  type="file"
                  multiple
                  onChange={handleFileSelect}
                  className="upload-button-input"
                />
                {selectedFiles && (
                  <div className="selected-files">
                    <div className="file-name">{selectedFiles}</div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="d-grid">
            {prescriptionError && (
              <span
                style={{ fontSize: "12px", color: "red", fontWeight: "600" }}
              >
                {prescriptionError}
              </span>
            )}
          </div>

          <Button
            className="PrimaryCTA"
            variant="contained"
            disableElevation
            sx={{ margin: "30px auto 20px auto" }}
            onClick={handlePostPrescription}
            disabled={
              prescriptionNote == "" ||
                prescriptionName == "" ||
                selectedFiles === ""
                ? true
                : false
            }
          >
            Add Prescription
          </Button>
        </DialogContent>
      </Dialog>

      {/* Cancel Dialog */}
      <Dialog
        className="Dialog Cancel--Dialog"
        open={openCancelConfirmationModal}
        onClose={handleCancelConfirmationClose}
        sx={{
          maxWidth: "610px",
          width: "98%",
          minWidth: "580px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {isCancelled !== null && !isCancelled && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "rgb(183 216 237 / 58%)",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "10",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <DialogContent className="Dialog--Content">
          <WarningRoundedIcon />
          <h6>
            Are you Sure want to cancel this Appointment? This action cannot be
            undone
          </h6>
          <div className="Content--Header d-flex align-items-center gap-2">
            <img
              src={clientData?.clientImage}
              width={45}
              style={{ borderRadius: "50%" }}
            />

            <div>
              <h6>{clientData?.clientName}</h6>
              <span>
                {clientData?.appointmentDate} | {clientData?.appointmentTime} |{" "}
                {clientData?.clientType}
              </span>
            </div>
          </div>

          <div className="CTA--Container d-flex align-items-center gap-3 mt-3">
            <Button
              className="PrimaryCTA--Outlined"
              variant="contained"
              disableElevation
              onClick={handleCancelConfirmationClose}
            >
              No, Take me back
            </Button>

            <Button
              className="PrimaryCTA"
              variant="contained"
              disableElevation
              onClick={handleCancel}
            >
              Yes, Cancel it
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Session Notes Dialog */}
      {openSessionNotesModal && (
        <Dialog
          className="Dialog SessionNotes--Dialog"
          open={openSessionNotesModal}
          onClose={handleSessionNotesClose}
          sx={{
            maxWidth: "610px",
            width: "98%",
            minWidth: "98%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <DialogTitle>
            {sessionNotesStep == 1 && "Add Session Notes"}

            {sessionNotesStep == 2 && "Session Details"}
          </DialogTitle>
          <DialogContent className="Dialog--Content">
            {sessionNotesStep == 1 && (
              <>
                <FormControl fullWidth className="my-4 ClientSelect--Form">
                  <InputLabel id="form-select-label">
                    Select Form
                  </InputLabel>
                  <Select
                    labelId="form-select-label"
                    id="form-select"
                    value={sessionNotesData.form_id}
                    onChange={(e) => {
                      setSessionNotesData((prevData) => ({
                        ...prevData,
                        form_id: e.target.value,
                      }));
                    }}
                    disabled={isFormsLoading}
                  >
                    {isFormsLoading ? (
                      <MenuItem disabled>Loading forms...</MenuItem>
                    ) : formsList?.length > 0 ? (
                      formsList?.map((item) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                      })
                    ) : (
                      <MenuItem disabled>No forms available</MenuItem>
                    )}
                  </Select>
                </FormControl>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Appointment Date"
                    format="YYYY-MM-DD"
                    value={dayjs(
                      sessionNotesData.appointment_date,
                      "YYYY-MM-DD"
                    )}
                    onChange={onSessionNoteAppiontmentDateChange}
                    sx={{ width: "100%" }}
                  />
                </LocalizationProvider>

                <TextField
                  id="outlined-multiline-static"
                  label="Contact Number"
                  //type="number"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  value={sessionNotesData.clientMobile}
                  fullWidth
                  sx={{ marginTop: "20px", marginBottom: "20px" }}
                  onChange={(e) => {
                    setSessionNotesData((prevData) => ({
                      ...prevData,
                      clientMobile: e.target.value,
                    }));
                  }}
                />

                <TextField
                  id="outlined-multiline-static"
                  label="Clients Address"
                  multiline
                  value={sessionNotesData.clientAddress}
                  fullWidth
                  sx={{ marginTop: "20px" }}
                  onChange={(e) => {
                    setSessionNotesData((prevData) => ({
                      ...prevData,
                      clientAddress: e.target.value,
                    }));
                  }}
                />

                <div className="d-flex gap-2 my-4">
                  <FormControl fullWidth className="ClientSelect--Form">
                    <InputLabel id="client-state-select-label">
                      Client State
                    </InputLabel>
                    <Select
                      labelId="client-state-select-label"
                      id="client-state-select"
                      value={sessionNotesData.client_state_id}
                      onChange={(e) => {
                        setSessionNotesData((prevData) => ({
                          ...prevData,
                          client_state_id: e.target.value,
                        }));
                      }}
                    >
                      {statesList?.map((item) => {
                        return (
                          <MenuItem key={item.code} value={item.id}>
                            <span>{item.name}</span>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>

                  <TextField
                    id="outlined-multiline-static"
                    label="Clients City"
                    multiline
                    value={sessionNotesData.clientCity}
                    fullWidth
                    onChange={(e) => {
                      setSessionNotesData((prevData) => ({
                        ...prevData,
                        client_city: e.target.value,
                      }));
                    }}
                  />

                  <TextField
                    id="outlined-multiline-static"
                    label="Postal Code"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    type="number"
                    value={sessionNotesData.clientPIN}
                    onChange={(e) => {
                      setSessionNotesData((prevData) => ({
                        ...prevData,
                        postal_code: e.target.value,
                      }));
                    }}
                    fullWidth
                  />
                </div>

                <Button
                  className="PrimaryCTA"
                  variant="contained"
                  disableElevation
                  disabled={isProceedDisabled}
                  sx={{ margin: "30px auto 20px auto" }}
                  onClick={handleProceed}
                >
                  Proceed
                </Button>
              </>
            )}
            {sessionNotesStep == 2 && (
              <>
                {sessionNotesForm.length > 0 &&
                  sessionNotesForm?.map((question, i) => {
                    return (
                      <div className="mb-3 d-flex flex-column">
                        <b>
                          {i + 1}. {question.name}
                        </b>

                        {question.type == "text" && (
                          <TextField
                            id="outlined-multiline-static"
                            label="Enter text"
                            multiline
                            value={textResponses[i]}
                            fullWidth
                            rows={4}
                            sx={{ marginTop: "20px", marginBottom: "20px" }}
                            onChange={(e) => {
                              updateTextResponse(i, e.target.value);
                            }}
                          />
                        )}

                        {question.type == "dropdown" && (
                          <FormControl
                            fullWidth
                            className="ClientSelect--Form my-3"
                          >
                            <InputLabel id={`question-dropdown-label-${i}`}>
                              Select
                            </InputLabel>
                            <Select
                              labelId={`question-dropdown-label-${i}`}
                              id={`question-dropdown-${i}`}
                              value={dropdownResponses[i] || ""}
                              onChange={(e) => {
                                const selectedOption = e.target.value;
                                updateDropdownResponse(i, selectedOption);
                              }}
                            >
                              {question?.options?.map((op) => (
                                <MenuItem key={op.id} value={op.id}>
                                  {op.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}

                        {question.type == "multiselection" && (
                          <FormGroup>
                            {question?.options?.map((item) => {
                              const isSelected = multiselectionResponses[i]
                                ? multiselectionResponses[i]?.some(
                                  (value) => value.id === item.id
                                )
                                : false;

                              return (
                                <FormControlLabel
                                  key={item.id}
                                  control={
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(e) => {
                                        const currentValues =
                                          multiselectionResponses[i] || [];
                                        let newValues;
                                        if (e.target.checked) {
                                          newValues = [...currentValues, item];
                                        } else {
                                          newValues = currentValues.filter(
                                            (v) => v.id !== item.id
                                          );
                                        }
                                        updateMultiselectionResponse(i, newValues);
                                      }}
                                    />
                                  }
                                  label={item.name}
                                />
                              );
                            })}
                          </FormGroup>
                        )}

                        {question.type == "boolean" && (
                          <FormControl component="fieldset">
                            <FormGroup>
                              {question?.options?.map((option, optionIndex) => (
                                <FormControlLabel
                                  key={option.id}
                                  control={
                                    <Checkbox
                                      checked={booleanResponses[i] === option.id}
                                      onChange={(e) => {
                                        const newBooleanResponses = { ...booleanResponses };
                                        newBooleanResponses[i] = e.target.checked ? option.id : "";
                                        setBooleanResponses(newBooleanResponses);
                                        updateResponse(i, { option_id: e.target.checked ? option.id : "" });
                                      }}
                                    />
                                  }
                                  label={option.name}
                                />
                              ))}
                            </FormGroup>
                          </FormControl>
                        )}

                        {question.type == "multiquestion" && (
                          <>
                            <TableContainer component={Paper}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {question.sub_questions?.map((subQuestion) => (
                                      <TableCell key={subQuestion.id}>{subQuestion.name}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {multiQuestionRows?.map((row) => (
                                    <TableRow
                                      key={row.name}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      {row.values?.map((item) => (
                                        <TableCell>
                                          {Object.values(item)}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <Button
                              variant="contained"
                              sx={{
                                width: "max-content",
                                marginTop: "15px",
                                textTransform: "capitalize",
                                borderRadius: "20px",
                              }}
                              startIcon={<AddIcon />}
                              onClick={() => {
                                // This button is removed as per the new simplified flow
                              }}
                            >
                              Add Row
                            </Button>
                          </>
                        )}
                      </div>
                    );
                  })}

                <div className="d-flex gap-2 mt-4">
                  <Button
                    variant="outlined"
                    onClick={() => setSessionNotesStep(1)}
                    sx={{ flex: 1 }}
                  >
                    Back
                  </Button>
                  <Button
                    className="PrimaryCTA"
                    variant="contained"
                    disableElevation
                    onClick={handleSaveSessionNote}
                    sx={{ flex: 1 }}
                    disabled={isSessionNoteSaving}
                  >
                    {isSessionNoteSaving ? <CircularProgress size={24} /> : "Save Session Note"}
                  </Button>
                </div>
              </>
            )}
          </DialogContent>
        </Dialog>
      )}

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AppointmentDefaultView;
